import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0007',
    ecrans: ['00-2'],
    params: ['?immcleint', '?immcod', '?vaesysimmtyptrs']
});
